import React from "react";
import * as PropTypes from "prop-types";
import {
  Box, Badge, Text, Button, useDisclosure, Icon,
} from "@chakra-ui/core";
import VenueType from "../../venues/venueTypes";
import { getCurrent, getScheduleByTime, UNDEFINED } from "./functions";
import { useInterval } from "../../../util/time";
import {
  FiClock
} from "react-icons/fi";
import ScheduleList from "./list";
import { useIntl } from "gatsby-plugin-intl";
import ScheduleCollapse from "./collapse"

const OPENING_TIMES = {
  undefined: "places.scheduleUndefined",
  closedNow: "places.scheduleClosedNow",
  openNow: "places.scheduleOpenNow",
};

const getOpeningColor = (open) => {
  if (typeof open === "boolean") {
    return open ? "green" : "red";
  }
  return "grey";
};

const Schedule = ({ venue, collapse, ...props }) => {
  const intl = useIntl();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [current, setCurrent] = React.useState(getCurrent());
  const [data, setData] = React.useState(null);
  useInterval(() => setCurrent(getCurrent()), 10000);
  React.useEffect(() => {
    if (!!venue) {
      if (!!venue.schedule && Object.keys(venue.schedule).length > 0) {
        setData(getScheduleByTime(current, venue));
      } else {
        setData({ openText: UNDEFINED });
      }
    } else {
      setData({ openText: UNDEFINED });
    }
  }, [current, venue]);
  return !!data && (
    <Box d="inline-block" {...props}>
      <Button
        size="xs"
        onClick={onOpen}
        aria-label={intl.formatMessage({ id: "places.seeSchedule" })}
        icon="arrow-up-down"
      >
        <Box d="inline" as={FiClock} color="blue.500" mr={1} />
        <Text d="inline-block">
          {data.scheduleText}
        </Text>
        <Icon name="arrow-up-down" ml={1} />
      </Button>
      <Badge mx={2} mt={[2, 0, 0, 0]} d="inline-block" variant="subtle" variantColor={getOpeningColor(data.open)}>
        {intl.formatMessage({ id: OPENING_TIMES[data.openText] })}
      </Badge>
      {collapse ? (
        <ScheduleCollapse
          isOpen={isOpen}
          schedule={venue.schedule}
          onClose={onClose}
          ml={2}
        />
      ) : (
        <ScheduleList
          schedule={venue.schedule}
          isOpen={isOpen}
          onClose={onClose}
          ml={2}
        />
      )}
    </Box>
  );
};

Schedule.propTypes = {
  venue: VenueType,
  collapse: PropTypes.bool,
}

Schedule.defaultProps = {
  venue: null,
  collapse: false,
};

export default Schedule;
